import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  year: number;       // 薪資年度 (e.g. 2024)
  month: number;      // 薪資月份 (1-12)
  deptFrom: string;   // 部門代號篩選起始
  deptTo: string;     // 部門代號篩選終止
  empFrom: string;    // 員工代號篩選起始
  empTo: string;      // 員工代號篩選終止
  deptLevel: number;  // 部門分級 1=部 2=處 3=課 4=組
  company: number;    // 公司篩選 1=台北渤揚 2=昆山渤揚 3=全部
}

export interface PayslipRow {
  empCode: string;
  empName: string;
  deptCode: string;
  deptName: string;
  month: number;
  addItems: number[];
  addTotal: number;
  deductItems: number[];
  deductTotal: number;
  netPay: number;
  retireSelf: number;
  healthIns: number;
  companyName: string;
}

export interface ItemDef {
  code: string;
  name: string;
}

export interface QueryResponse {
  payslips: PayslipRow[];
  addItemDefs: ItemDef[];
  deductItemDefs: ItemDef[];
  totalCount: number;
  yearMonth: string;
  thanksMessage: string;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const pw9335Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9335/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/pw9335/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
